module.exports = __webpack_public_path__ + "static/artist-development-case-study-mobile-3291a275358fa265910ab4f246bf4324.png";